/**
 * WomensHealthStep.constants.js
 *
 * Option data for Screen 11 "Women's Health" (FSD Section 4, Screen 11).
 * This step is only ever rendered when Gender = Female (Screen 2) — the
 * wizard gates it entirely, so nothing in here needs to re-check gender.
 */

// "At least one selection or 'None'" — same shape as Screen 6's Medical
// Conditions (multi-select + None), so CONDITION_OPTIONS follows that
// pattern rather than four independent toggles.
export const CONDITION_OPTIONS = [
  { id: "pregnant", label: "Pregnant" },
  { id: "breastfeeding", label: "Breastfeeding" },
  { id: "pcos", label: "PCOS" },
  { id: "menopause", label: "Menopause" },
];

export const NONE_OPTION_ID = "none";

export const TRIMESTER_OPTIONS = [
  { id: "", label: "Select trimester" },
  { id: "first", label: "First trimester" },
  { id: "second", label: "Second trimester" },
  { id: "third", label: "Third trimester" },
];

export const YES_NO_OPTIONS = [
  { id: "yes", label: "Yes" },
  { id: "no", label: "No" },
];

export const WOMENS_HEALTH_INITIAL_DATA = {
  conditions: [], // e.g. ["pregnant"], or ["none"]
  trimester: "",
  dueDate: "",
  doctorAdvisedRestrictions: "",
  gestationalDiabetes: null,
};
